import * as React from "react";
import * as ReactDOM from "react-dom";
import {Page_Home} from "./src/pages/page-home/Page_Home";

(() => {
    const root: HTMLElement = document.getElementById('root');
    ReactDOM.render(<Page_Home/>, root);
})();